import * as React from "react";
import SingleCard from "./SingleCard";
import DoubleCard from "./DoubleCard";
import TripleCard from "./TripleCard";
export default function MProductsCard(props) {
    let { columnNum } = props;
    if (![1, 2, 3].includes(columnNum)) {
        columnNum = 2;
    }
    const nextProps = transformQnparams(props);
    let ProductSkeleton;
    if (columnNum === 1) {
        ProductSkeleton = SingleCard;
    }
    else if (columnNum === 3) {
        ProductSkeleton = TripleCard;
    }
    else {
        ProductSkeleton = DoubleCard;
    }
    return React.createElement(ProductSkeleton, Object.assign({}, nextProps));
}
function transformQnparams(props) {
    let qnParams = {};
    if (!props.notUseQnparams) {
        qnParams = {
            w: 300,
        };
    }
    return Object.assign(Object.assign({}, props), { qnParams });
}
